import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MyWorkPage } from "@/features/my-work/MyWorkPage";

const search = z.object({
  tab: z.enum(["today", "week", "overdue", "nodate", "done"]).optional(),
});

export const Route = createFileRoute("/_app/my-work/")({
  validateSearch: search,
  component: () => <MyWorkPage search={Route.useSearch()} />,
});
